import { useCallback, useEffect } from 'react'
import { useLocalStorage } from './useLocalStorage'

export type ThemeChoice = 'light' | 'dark' | 'system'

function apply(choice: ThemeChoice) {
  const dark =
    choice === 'dark' ||
    (choice === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches)
  document.documentElement.dataset.theme = dark ? 'dark' : 'light'
}

export function useTheme() {
  const [choice, setChoice] = useLocalStorage<ThemeChoice>('ail.theme', 'system')

  useEffect(() => {
    apply(choice)
    if (choice !== 'system') return
    const mq = window.matchMedia('(prefers-color-scheme: dark)')
    const onChange = () => apply('system')
    mq.addEventListener('change', onChange)
    return () => mq.removeEventListener('change', onChange)
  }, [choice])

  const cycle = useCallback(() => {
    setChoice((c) => (c === 'light' ? 'dark' : c === 'dark' ? 'system' : 'light'))
  }, [setChoice])

  return { choice, setChoice, cycle }
}
